const SCROLLABLE = new Set(['auto', 'scroll']);

export function scrollerOf(el) {
  for (let node = el?.parentElement; node && node !== document.body; node = node.parentElement) {
    if (SCROLLABLE.has(getComputedStyle(node).overflowY) && node.scrollHeight > node.clientHeight)
      return node;
  }
  return null;
}

export function revealInScroller(el, { block = 'center', behavior = null } = {}) {
  const scroller = scrollerOf(el);
  if (!scroller) return false;
  const box = el.getBoundingClientRect();
  const frame = scroller.getBoundingClientRect();
  const offset = box.top - frame.top;
  const fits = offset >= 0 && offset + box.height <= scroller.clientHeight;
  const top =
    block === 'center'
      ? scroller.scrollTop + offset - (scroller.clientHeight - box.height) / 2
      : block === 'start'
        ? scroller.scrollTop + offset - (parseFloat(getComputedStyle(el).scrollMarginTop) || 0)
        : fits
          ? scroller.scrollTop
          : scroller.scrollTop +
            (offset < 0 ? offset : offset + box.height - scroller.clientHeight);
  const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  scroller.scrollTo({
    top: Math.max(0, top),
    behavior: behavior ?? (reduce ? 'auto' : 'smooth'),
  });
  return true;
}
